<template>
  <div>
    <img
      :src="`/packages/crypto-currency-images/svg/${symbol}.svg`"
      :alt="`${symbol} icon`"
      :style="{ width: size, height: size }"
      @error="toggleFallback()"
      v-show="!useFallback"
      :key="`${symbol}`"
    />
    <img
      src="/packages/crypto-currency-images/png/fallback.png"
      :style="{ width: size, height: size }"
      :alt="`${symbol} fallback icon`"
      v-show="useFallback"
      :key="`${symbol} fallback`"
    />
  </div>
</template>

<script setup>
import { ref } from "vue";

const useFallback = ref(false);

const props = defineProps({
  symbol: { type: String, default: "btc" },
  size: { type: String, default: "25px" },
});

const toggleFallback = () => {
  useFallback.value = true;
};
</script>

<style lang="scss" scoped></style>
